import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import WaldogramMessageInput from './WaldogramMessageInput';
import WaldogramAddressPlaceholder from './WaldogramAddressPlaceholder';
import WaldogramSecondaryPhotoPlaceholder from './WaldogramSecondaryPhotoPlaceholder';
import WaldogramMainPhotoPlaceholder from './WaldogramMainPhotoPlaceholder';
import { WALDOGRAM_PRINT_TYPE } from '../../../apps/web-gallery/constants/web-gallery-waldogram-constants';
import ScissorsIcon from '../../icons/ScissorsIcon';
import { getAsset } from '../../../util/assets';

const propTypes = {
  config: PropTypes.shape({
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        photo: PropTypes.shape({
          id: PropTypes.string,
          position: PropTypes.number,
        }),
      }),
    ),
  }),
  onPhotoSelect: PropTypes.func.isRequired,
  onPhotoCropboxSet: PropTypes.func.isRequired,
  onCaptionSet: PropTypes.func.isRequired,
  onCabinNameSet: PropTypes.func,
  onIdentityNameSet: PropTypes.func.isRequired,
  onEmojiSet: PropTypes.func.isRequired,
  externalAddresses: PropTypes.arrayOf(PropTypes.object),
  mainSlotRef: PropTypes.object,
};

const WaldogramTwoSidedTemplate = ({
  config,
  onPhotoSelect,
  onPhotoCropboxSet,
  onCaptionSet,
  onCabinNameSet,
  onIdentityNameSet,
  onEmojiSet,
  externalAddresses,
  mainSlotRef,
}) => {
  const { photos } = config;
  const mainPhoto = photos.find(photo => photo.position === 0);
  const secondaryPhoto = photos.find(photo => photo.position === 1);

  return (
    <Fragment>
      <div className="waldogram-template-wrap waldogram-template-twosided side-a">
        <div className="waldogram-template">
          <div ref={mainSlotRef} className="waldogram-template-slot-a">
            <WaldogramMainPhotoPlaceholder
              photo={mainPhoto.photo}
              cropbox={mainPhoto.cropbox}
              onPhotoSelect={onPhotoSelect}
              onPhotoCropboxSet={onPhotoCropboxSet}
            />
          </div>

          {mainPhoto.photo && (
            <Fragment>
              <div className="waldogram-safe-area" />
              <ScissorsIcon className="waldogram-safe-area-scissors" />
            </Fragment>
          )}
        </div>
      </div>

      <div className="waldogram-template-wrap waldogram-template-twosided side-b">
        <div className="waldogram-template">
          <div className="waldogram-template-slot-a">
            <WaldogramMessageInput
              onChange={onCaptionSet}
              value={config.caption}
              type={WALDOGRAM_PRINT_TYPE.OFFSITE}
            />
          </div>

          <div className="waldogram-template-slot-b" />
          <div className="waldogram-template-slot-c">
            <WaldogramSecondaryPhotoPlaceholder
              photo={secondaryPhoto.photo}
              emoji={config.emoji}
              onPhotoSelect={onPhotoSelect}
              onPhotoCropboxSet={onPhotoCropboxSet}
              onEmojiSet={onEmojiSet}
            />
          </div>
          <div className="waldogram-template-slot-d">
            <WaldogramAddressPlaceholder
              onCabinNameSet={onCabinNameSet}
              onIdentityNameSet={onIdentityNameSet}
              identityName={config.identityName}
              cabinName={config.cabinName}
              externalAddresses={externalAddresses}
            />

            <img
              src={getAsset('/barcode.svg')}
              alt=""
              className="waldogram-barcode"
            />

            <img
              src={getAsset('/postage-paid.svg')}
              alt=""
              className="waldogram-postage-paid"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

WaldogramTwoSidedTemplate.propTypes = propTypes;

export default WaldogramTwoSidedTemplate;
